import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "input-container" }
const _hoisted_2 = ["aria-describedby", "aria-invalid", "id"]
const _hoisted_3 = ["aria-describedby", "aria-invalid", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidatedInput = _resolveComponent("ValidatedInput")!
  const _component_AddressContainer = _resolveComponent("AddressContainer")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tribute-input-container", _ctx.isModalDisplay ? 'rd-mt-3' : 'rd-mt-6'])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["rd-flex rd-font-bold", _ctx.isModalDisplay ? 'rd-mb-2.5' : 'rd-mb-4'])
    }, _toDisplayString(_ctx.component.customData.tributeInformationLabel), 3),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["form-row", { 'md:rd-gap-x-4': _ctx.fieldStyle != _ctx.FieldStyle.Compact }])
      }, [
        _createVNode(_component_ValidatedInput, {
          id: _ctx.component.id,
          value: _ctx.renderStore.tribute.tributeFirstName,
          label: "First Name",
          class: _normalizeClass(["rd-w-full md:rd-flex-equal", { 'rd-mb-4 md:rd-mb-0': _ctx.fieldStyle != _ctx.FieldStyle.Compact }]),
          name: "tributeFirstName",
          isRequired: true,
          maxLength: 75
        }, {
          input: _withCtx((inputProps) => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.renderStore.tribute.tributeFirstName) = $event)),
              placeholder: "First Name",
              "aria-describedby": inputProps.describedBy ?? undefined,
              "aria-required": "true",
              "aria-invalid": inputProps.isInvalid,
              id: _ctx.component.id + '_tributeFirstName'
            }, null, 8, _hoisted_2), [
              [_vModelText, _ctx.renderStore.tribute.tributeFirstName]
            ])
          ]),
          _: 1
        }, 8, ["id", "value", "class"]),
        _createVNode(_component_ValidatedInput, {
          id: _ctx.component.id,
          value: _ctx.renderStore.tribute.tributeLastName,
          label: "Last Name",
          class: "rd-w-full md:rd-flex-equal",
          name: "tributeLastName",
          isRequired: true,
          maxLength: 75
        }, {
          input: _withCtx((inputProps) => [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.renderStore.tribute.tributeLastName) = $event)),
              placeholder: "Last Name",
              "aria-describedby": inputProps.describedBy ?? undefined,
              "aria-required": "true",
              "aria-invalid": inputProps.isInvalid,
              id: _ctx.component.id + '_tributeLastName'
            }, null, 8, _hoisted_3), [
              [_vModelText, _ctx.renderStore.tribute.tributeLastName]
            ])
          ]),
          _: 1
        }, 8, ["id", "value"])
      ], 2)
    ]),
    (_ctx.component.customData.showTributeAddress)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: _normalizeClass(["input-container", _ctx.isModalDisplay ? '!rd-mt-2.5' : '!rd-mt-4'])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass({ 'fields-compact': _ctx.fieldStyle == _ctx.FieldStyle.Compact })
          }, [
            _createVNode(_component_AddressContainer, {
              id: _ctx.component.id + '_tributeAddress',
              passedAddress: _ctx.renderStore.tribute.tributeAddress,
              required: false,
              name: "Tribute Address",
              address1Label: "Tribute Address",
              address1Placeholder: "Address 1",
              address2Placeholder: "Address 2",
              cityPlaceholder: "City",
              statePlaceholder: "State",
              postalPlaceholder: "Postal Code",
              countryPlaceholder: "Country",
              onUpdateAddress: _ctx.updateAddress
            }, null, 8, ["id", "passedAddress", "onUpdateAddress"])
          ], 2)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}